import React from 'react'
import './header.scss'

function Header() {
	return (
		<div>
			<div className='navbar'>
				<h1>Get Laugh</h1>
			</div>
		</div>
	)
}

export default Header
